import { IosSwitch } from "../../../components";
import { Column } from "../../../components/dataTable/dataTable";
import { ExtOrganizationType } from "../../../types";
import { formattedDate } from "../../../utils";

export const organizationColumns = (
  currentPage: number,
  rowsPerPage: number,
  handleActiveChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    org: ExtOrganizationType
  ) => void
): Column<ExtOrganizationType>[] => {
  return [
    {
      key: "logo",
      label: "Logo",
      render: (org) => (
        <img
          src={org.logo?.url || "/placeholder-org.png"}
          alt={org.name}
          style={{
            width: 50,
            height: 50,
            objectFit: "cover",
            borderRadius: 8,
            border: "1px solid #ddd",
          }}
        />
      ),
    },
    {
      key: "name",
      label: "Name",
      render: (org) => <strong>{org.name}</strong>,
    },
    {
      key: "email",
      label: "Email",
      render: (org) => org.email || "-",
    },
    {
      key: "description",
      label: "Description",
      render: (org) => org.description || "-",
    },
    {
      key: "createdAt",
      label: "Created On",
      align: "center",
      render: (org) => formattedDate(org.createdAt),
    },
    // {
    //   key: "totalNGOs",
    //   label: "Total NGOs",
    //   align: "center",
    //   render: (org) => org.totalNGOs ?? 0,
    // },
    // {
    //   key: "totalCities",
    //   label: "Total Cities",
    //   align: "center",
    //   render: (org) => org.totalCities ?? 0,
    // },
    {
      key: "isActive",
      label: "Active",
      align: "center",
      render: (org) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <IosSwitch
            checked={org.isActive ?? false}
            onChange={(e) => handleActiveChange(e, org)}
          />
        </div>
      ),
    },

    {
      key: "actions",
      label: "Actions",
      align: "center",
    },
  ];
};
